import {Pipe, PipeTransform} from '@angular/core';
import {FieldDto} from '../../../Models/Tasks/General/task.interface';
import {FieldTypesEnum} from '../../../Shared/Enum/field-types.enum';

@Pipe({
  name: 'tasksFamily',
  standalone: false
})
export class TasksFamilyPipe implements PipeTransform {

  transform(items: FieldDto[], filters: { menu: string }): FieldDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filters.menu === 'incidents') {

      items = items.filter((family) =>
        family.sub_familias.some((subfamily) =>
          subfamily.campos.some((field) => field.observaciones))
      );

    }

    if (filters.menu === 'pendents') {

      items = items.filter((family) =>
        family.sub_familias.some((subfamily) =>
          subfamily.campos.some((field) => !field.value && field.tipo !== FieldTypesEnum.title))
      );

    }

    return items;

  }

}
